package com.merkost.handpass.api.dto.listing

import com.merkost.handpass.api.dto.MonetaryAmount
import com.merkost.handpass.api.enums.Condition
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateListingRequest(
    @SerialName("category_id") val categoryId: String,
    val title: String,
    val description: String? = null,
    val price: MonetaryAmount,
    val condition: Condition = Condition.LIKE_NEW,
    val images: List<String> = emptyList(),
    val location: ListingLocationDto? = null,
    @SerialName("shipping_available") val shippingAvailable: Boolean = false,
    @SerialName("is_negotiable") val isNegotiable: Boolean = false
)
